import { useImageContext } from "./providers/Image";
import { useAppContext } from "../../AppProvider";
import InputIcon from "../../Components/Inputs/InputIcon/InputIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getFieldError } from "../../utilities/utilities";
import { faICursor, faLoader } from "../../utilities/fontawesomeIcons";
import { ArticleImage } from "../../Models/ArticleImage";
import NoAvailableImage from "../../assets/images/no-image-available.png";

export const Image = () => {
  const { dictionary } = useAppContext();
  const { data, action, error, loader, onChange } = useImageContext();

  const handleChange = (
    name: string,
    value: string | boolean | number | object | null,
    key: string
  ) => {
    if (action !== "details") {
      onChange(
        {
          ...data,
          [name]: value,
        } as ArticleImage,
        key as keyof ArticleImage
      );
    }
  };

  return loader ? (
    <div className="text-center mt-2">
      <FontAwesomeIcon icon={faLoader} spin size="2x" />
    </div>
  ) : (
    <div className="d-flex flex-column h-100">
      <div
        id="img-container"
        className="flex-grow-1 d-flex justify-content-center align-items-center overflow-hidden"
      >
        <img
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            width: "auto",
            height: "auto",
            objectFit: "contain",
            display: "block",
          }}
          src={data?.imageUrl || NoAvailableImage}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = NoAvailableImage;
          }}
        />
      </div>
      <div className="mt-2">
        <label className="label-2">
          {dictionary.words.url} {dictionary.words.image}
        </label>
        <InputIcon
          name="imageUrl"
          value={data?.imageUrl}
          type="text"
          placeholder="https://allabox.it/static/media/no-image-available.5f09172c692a365b3843.png"
          onChange={({ target }) => {
            handleChange(target.name, target.value, "imageUrl");
          }}
          disabled={action === "details"}
          icon={faICursor}
          error={getFieldError(error, "imageUrl")}
        />
      </div>
    </div>
  );
};
